import Link from 'next/link'
import React, { useEffect, useState } from 'react'
import { eBookData, getCategoryName } from '@/assets/data/blog-categories'


const ResourcesDropdown = (props) => {
    const { open, onClick, cardData, loader, caseCardData, pressCardData } = props

    // State to store the hovered card data
    const [hoveredCardData, setHoveredCardData] = useState(null);

    useEffect(() => {
        setHoveredCardData({
            id: "blogs",
            path: "/blog",
            title: "Blogs & Articles",
            desc: "The latest industry news, updates, interesting articles and info.",
            data: cardData
        })
    }, [cardData])


    // Function to handle mouse enter event
    const handleMouseEnter = (data) => {
        setHoveredCardData(data); // Update the cardData to the hovered item
    };
    // Function to handle mouse leave event
    const handleMouseLeave = () => {
        // setHoveredCardData(fallbackData); // Reset back to original cardData
    };

    const resourcesList = [
        {
            id: "blogs",
            path: "/blog",
            title: "Blogs & Articles",
            desc: "A hub for industry news, updates, and interesting articles.",
            icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect x="0.25" y="0.25" width="23.5" height="23.5" rx="3.75" stroke="black" stroke-opacity="0.2" stroke-width="0.5"/>
    <path d="M11.9987 8.66667C11.9987 7.95942 11.7177 7.28115 11.2176 6.78105C10.7176 6.28095 10.0393 6 9.33203 6H5.33203V16H9.9987C10.5291 16 11.0378 16.2107 11.4129 16.5858C11.788 16.9609 11.9987 17.4696 11.9987 18M11.9987 8.66667V18M11.9987 8.66667C11.9987 7.95942 12.2796 7.28115 12.7797 6.78105C13.2798 6.28095 13.9581 6 14.6654 6H18.6654V16H13.9987C13.4683 16 12.9596 16.2107 12.5845 16.5858C12.2094 16.9609 11.9987 17.4696 11.9987 18" stroke="#EB532E" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
            data: cardData
        },
        {
            id: "case-studies",
            path: "/case-studies",
            title: "Case Studies",
            desc: "A collection of detailed examples and analyses showcasing solutions or successes.",
            icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect x="0.25" y="0.25" width="23.5" height="23.5" rx="3.75" stroke="black" stroke-opacity="0.25" stroke-width="0.5"/>
    <path d="M10 6H7.33333C6.97971 6 6.64057 6.14048 6.39052 6.39052C6.14048 6.64057 6 6.97971 6 7.33333V10M10 6H16.6667C17.0203 6 17.3594 6.14048 17.6095 6.39052C17.8595 6.64057 18 6.97971 18 7.33333V10M10 6V18M6 10V16.6667C6 17.0203 6.14048 17.3594 6.39052 17.6095C6.64057 17.8595 6.97971 18 7.33333 18H10M6 10H18M18 10V16.6667C18 17.0203 17.8595 17.3594 17.6095 17.6095C17.3594 17.8595 17.0203 18 16.6667 18H10" stroke="#EB532E" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
            data: caseCardData
        },
        {
            id: "press",
            path: "/press",
            title: "Press",
            desc: "News, press releases, and resources related to media coverage.",
            icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect x="0.25" y="0.25" width="23.5" height="23.5" rx="3.75" stroke="black" stroke-opacity="0.2" stroke-width="0.5"/>
    <path d="M11.7333 15.2C11.6633 15.4539 11.5439 15.6915 11.3821 15.8993C11.2202 16.107 11.019 16.2809 10.7899 16.4109C10.5609 16.5409 10.3085 16.6245 10.0471 16.6569C9.78574 16.6894 9.52054 16.67 9.26665 16.6C9.01276 16.53 8.77515 16.4106 8.56739 16.2487C8.35963 16.0869 8.18579 15.8857 8.05578 15.6566C7.92578 15.4276 7.84217 15.1752 7.80972 14.9138C7.77726 14.6524 7.79661 14.3872 7.86665 14.1333M6 11.3333L18 8V16L6 13.3333V11.3333Z" stroke="#EB532E" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
            data: pressCardData
        },
        {
            id: "resource-center",
            path: "/resource-center",
            title: "eBook & Market Reports",
            desc: "News, press releases, and resources related to media coverage.",
            icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.25" y="0.25" width="23.5" height="23.5" rx="3.75" stroke="black" stroke-opacity="0.25" stroke-width="0.5"/>
<path d="M6.66406 17V7.00004C6.66406 6.55801 6.83966 6.13409 7.15222 5.82153C7.46478 5.50897 7.8887 5.33337 8.33073 5.33337H17.3307V18.6667H8.33073C7.8887 18.6667 7.46478 18.4911 7.15222 18.1786C6.83966 17.866 6.66406 17.4421 6.66406 17ZM6.66406 17C6.66406 16.558 6.83966 16.1341 7.15222 15.8215C7.46478 15.509 7.8887 15.3334 8.33073 15.3334H17.3307" stroke="#EB532E" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
            data: eBookData
        },
    ]

    let redirectUrl = `/${hoveredCardData?.id}/${hoveredCardData?.data?.category}/${hoveredCardData?.data?.slug}`
    if (hoveredCardData?.id !== "blogs") {
        redirectUrl = `/${hoveredCardData?.id}/${hoveredCardData?.data?.slug}`
    } else {
        redirectUrl = `/${hoveredCardData?.data?.category}/${hoveredCardData?.data?.slug}`
    }

    return (
        <div className={` ${open ? 'flex' : 'hidden'} cursor-auto z-10 border border-[#E7E7E7] shadow-[#00000026] rounded-xl overflow-hidden bg-white absolute w-[720px] left-[-300px] top-16`}>
            <div className='p-5 w-1/2 flex flex-col justify-between'>
                {resourcesList?.map(e => (
                    <Link
                        onClick={onClick}
                        key={e?.id}
                        href={e?.path}
                        className='flex items-center p-4 gap-4 rounded-lg transition-all duration-300 hover:bg-[#98AABE26]'
                        onMouseEnter={() => handleMouseEnter(e)} // Update on hover
                        onMouseLeave={handleMouseLeave} // Reset on mouse leave
                    >
                        <div dangerouslySetInnerHTML={{ __html: e?.icon }} />
                        <div className='flex flex-col gap-1 items-start text-start'>
                            <p className='text-lg text-black'>{e?.title}</p>
                            {/* <p className='text-[13px] text-secondary leading-4'>{e?.desc}</p> */}
                        </div>
                    </Link>
                ))}
            </div>

            <div className='min-w-[360px] w-1/2 border-l border-[#E7E7E7] bg-[#98AABE26] p-5'>
                {loader || !hoveredCardData?.data?.slug ?
                    <div className='w-full h-full rounded-lg bg-gray-300 animate-pulse'>
                    </div> :
                    <Link onClick={onClick} href={redirectUrl}>
                        <div
                            className={`relative cursor-pointer bg-cover bg-center w-full h-full rounded-lg shadow-lg overflow-hidden`}
                            style={{
                                backgroundImage: `url("${encodeURI(hoveredCardData?.data?.thumbNail)}")`,
                            }}
                        >
                            <div className="relative bg-gradient-to-b from-transparent via-[#35343A]/80 to-[#35343A]/100 hover:via-[#EB532E]/80 hover:to-[#EB532E]/100 text-left transition-all duration-300 z-10 p-[30px] text-white flex flex-col justify-between h-full">
                                <div className='flex flex-col gap-2'>
                                    <span className="text-base leading-5 font-bold text-white">
                                        {getCategoryName(hoveredCardData?.data?.category)}
                                    </span>
                                    {hoveredCardData?.data?.readingTime ?
                                        <span className="text-[10px] leading-6 font-light text-white">
                                            {hoveredCardData?.data?.readingTime} MINUTES READ
                                        </span> :
                                        hoveredCardData?.data?.date ?
                                            <span className="text-[10px] leading-6 font-light text-white">
                                                {hoveredCardData?.data?.date}
                                            </span> : null
                                    }
                                </div>
                                <div>
                                    <h2 className="text-[20px] leading-6 font-bold mt-2 line-clamp-3">{hoveredCardData?.data?.title}</h2>
                                    <p className='mt-4 text-[14px] font-light leading-7'>
                                        Read More <span className='ml-3'> →</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Link>
                }
            </div>
        </div>
    )
}

export default ResourcesDropdown;
